export const projectList = [
  {
    title: "Ini Lho ITS! 2024",
    role: "Frontend Developer",
    duration: "Oct 2023 - March 2024",
    description:
      "Ini Lho ITS! is the biggest student-organized event at ITS, aimed at inspiring high school students across Indonesia. The website serves as an information hub for event details and a platform for purchasing tryout tickets. In 2024, Ini Lho ITS! successfully attracted over 3,000 participants and delivered a seamless ticketing experience.",
    link: "https://ilits2024-frontend.vercel.app/",
    techStack: [
      "Next JS",
      "Typescript",
      "Tailwind CSS",
      "Axios",
      "Tanstack Query",
      "AOS",
      "React Hook Form",
      "Zustand",
    ],
    bgImage: "bg-projectsIlits",
  },
  {
    title: "TedxITS 2024",
    role: "Frontend Developer",
    duration: "Feb 2024 - June 2024",
    description:
      "TEDxITS 2024 is an independently organized event that provides a platform for the ITS community to share impactful and unexplored ideas. The goal is to ignite discussions, foster connections, and build a stronger sense of community. The official TEDxITS 2024 website features advanced animations built with pure CSS and facilitates seamless Ted Talks registration and payment processing for attendees.",
    link: "https://tedxits2024.vercel.app/",
    techStack: [
      "Next JS",
      "Typescript",
      "Tailwind CSS",
      "Axios",
      "Tanstack Query",
      "AOS",
      "Frammer Motion",
      "Headless UI",
      "Zustand",
    ],
    bgImage: "bg-projectsTedx",
  },
  {
    title: "SniffITS",
    role: "Frontend Developer",
    duration: "Nov 2023 - March 2024",
    description:
      "SniffITS is an innovative project developed as part of the Matching Fund 2023 program by Kedaireka.id, focusing on creating a prototype for ship emission monitoring devices to support smart and green ports. This project integrates drone technology from Beehive Drones, equipped with advanced sensors capable of detecting pollutants such as NO2, NO, SO2, and other particulates. The collected data is transmitted in real-time to a centralized server and visualized through a dashboard. As a Frontend Developer, I contributed to building the web platform, ensuring seamless data visualization and an intuitive user interface.",
    link: "-",
    techStack: [
      "Next JS",
      "Typescript",
      "Tailwind CSS",
      "Axios",
      "Tanstack Query",
      "React Hook Form",
    ],
    bgImage: "bg-projectsSniffits",
  },
  {
    title: "Ini Lho ITS! 2025",
    role: "Project Manager",
    duration: "Oct 2024 - March 2025",
    description:
      "Ini Lho ITS! 2025 continues the mission of inspiring high school students across Indonesia. As Project (and Product) Manager, I ensured timely feature releases, streamlined cross-division collaboration, and optimized project timelines. Together with the IT Dev team, we were able to reach and engage 15,000+ active users and improve website performance and engagement by total more than 30% from the previous year.",
    link: "https://inilho.its.ac.id/",
    techStack: [
      "Github Projects",
      "Scrum",
      "Kanban",
      "Agile",
      "Code Review",
      "Next JS",
      "AWS S3",
      "AWS Cloudfront",
    ],
    bgImage: "bg-projectsIlits25",
  },
  {
    title: "Raih Asa",
    role: "Project Manager",
    duration: "Feb 2025 - Present",
    description:
      "Raih Asa is a platform dedicated to guiding students in securing scholarships through tailored mentoring, exclusive classes, and curated programs such as the Scholarships Fair and Booster Series. As the Project Manager, I played a key role in brainstorming features with the operational manager, devising long-term strategic plans to increase user engagement and retention, and ensuring that the product roadmap aligned with organizational goals. Additionally, I was responsible for creating Product Requirement Documents (PRD), Software Requirement Specifications (SRS), breaking down feature timelines, and estimating project costs.",
    link: "https://www.raihasa.id/",
    techStack: [
      "Miro",
      "Strategic Thinking",
      "Problem Solving",
      "Decision Making",
      "Time Management",
    ],
    bgImage: "bg-raihasa",
  },
  {
    title: "Igsas | Personal Project",
    role: "Frontend Developer",
    duration: "Feb 2025",
    description:
      "IGSAS is one of Turkey's largest fertilizer producers, dedicated to increasing agricultural productivity through innovative solutions and sustainable practices. As part of a personal project, I recreated the IGSAS website with a focus on replicating and customizing its animation styles. This journey not only sharpened my frontend skills but also deepened my understanding of GSAP, enabling me to craft smooth and interactive user experiences.",
    link: "/igsas",
    techStack: [
      "React JS",
      "Typescript",
      "Tailwind CSS",
      "GSAP",
      "Frammer Motion",
      "Scroll Magic",
    ],
    bgImage: "bg-igsas",
  },
  {
    title: "Dropbox | Personal Project",
    role: "Frontend Developer",
    duration: "Feb 2025",
    description:
      "As a personal challenge, I recreated the animation styles from Dropbox's Brand Framework because I was fascinated by its simplicity yet tricky implementation. Despite the animations appearing straightforward, they required meticulous handling of multiple elements simultaneously. The process pushed me beyond my comfort zone, sharpening my GSAP skills along the way. While the result may not be perfect, it was a rewarding experience that significantly deepened my understanding of complex web animations.",
    link: "/framework",
    techStack: [
      "React JS",
      "Typescript",
      "Tailwind CSS",
      "GSAP",
      "Frammer Motion",
      "Scroll Magic",
    ],
    bgImage: "bg-framework",
  },

  {
    title: "Personal Website",
    role: "Frontend Developer",
    duration: "March 2025",
    description:
      "You are here!  This project was my fastest build yet! I recreated a personal website using GSAP, tackling complex animations and fine-tuning multiple elements—all within just 2 days. Despite the challenges, I managed to bring the concept to life smoothly. While it’s not perfect, this experience greatly enhanced my understanding of GSAP and refined my animation skills.   I’d also like to give credit to @Yusriel Muttaqien for the inspiration behind this project.",
    link: "-",
    techStack: [
      "React JS",
      "Typescript",
      "Tailwind CSS",
      "GSAP",
      "Frammer Motion",
      "Scroll Magic",
    ],
    bgImage: "bg-personal",
  },
];
